module.exports = __webpack_public_path__ + "img/logo.0ad785d3.svg";